if (typeof jQuery != "undefined") {
    (function($) {
        /** Message handler
         *
         * Handler for outputting a message as first element within a container element
         *
         * @param container -- jQuery wrapped DOM element of container to put the message in
         * @param messageClassName (optional) -- classname of the message container (default 'message')
         * @param option_all by hidemessage is to clean up all messages
         */
        ZZ.MessageHandler = function(container, messageClassName) {
            var base = this;
            base.container = container;
            base.messageClassName = messageClassName || "message";

            base.messageElement = $(
                '<div class="' + base.messageClassName + '" />'
            );
            base.messageElement.hide();

            base.container.prepend(base.messageElement);
        };

        ZZ.MessageHandler.prototype = {
            showMessage: function(message) {
                var base = this;
                if (typeof message !== "undefined" && $.trim(message) !== "") {
                    base.messageElement.html(message);
                }
                base.messageElement.slideDown(200);
            },

            hideMessage: function(option_all) {
                var base = this;

                if (option_all == "all") {
                    $(
                        "." + base.messageClassName + ':not(".static-message")'
                    ).each(function(index, elem) {
                        if (
                            $(elem).css("display") === "block" ||
                            $(elem).css("display") === "inline-block"
                        ) {
                            $(elem).slideUp(50);
                        }
                    });
                }

                if (option_all == "warnings") {
                    $(
                        '.error-message:not(".static-message"), .succes-message:not(".static-message")'
                    ).each(function(index, elem) {
                        if (
                            $(elem).css("display") === "block" ||
                            $(elem).css("display") === "inline-block"
                        ) {
                            $(elem).slideUp(50);
                        }
                    });
                }

                if (option_all === undefined) {
                    if (
                        base.messageElement.css("display") === "block" ||
                        base.messageElement.css("display") === "inline-block"
                    ) {
                        base.messageElement.slideUp(50);
                    }
                }
            }
        };
    })(jQuery);
}
